import { useApiQuery } from '../useApiQuery';
import { reminderKeys } from '@/lib/queryKeys';
import { remindersV2 } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { ReminderPreviewNextStep } from '@/types/reminder';

/**
 * Render-only preview of the next scheduled step (spec §13.3 "Preview next").
 *
 * Lazy: pass `enabled: false` until the user opens the preview dialog so we
 * don't pay the LLM round-trip on every list render.
 */
export function usePreviewNextStep(
  id: string | undefined | null,
  options: { enabled?: boolean } = {},
) {
  const { enabled = true } = options;

  return useApiQuery<ReminderPreviewNextStep>({
    queryKey: reminderKeys.previewNextStep(id ?? '__none__'),
    queryFn: () =>
      apiGet<ReminderPreviewNextStep>(operationsClient, remindersV2.previewNextStep(id!)),
    enabled: Boolean(id) && enabled,
    showErrorToast: false,
    // Preview content is rendered fresh server-side; don't cache stale copy.
    staleTime: 0,
    gcTime: 60_000,
  });
}
